import { Input, Component, OnInit , OnChanges, SimpleChanges , ChangeDetectorRef, OnDestroy} from '@angular/core';
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import { DomSanitizer } from "@angular/platform-browser";
import { MatSelectChange, MatTabChangeEvent } from '@angular/material';
import { Article , Year, Month, CategoryGroup } from './ceo-desk.model';
import { CeoDeskService } from './ceo-desk.service';
import { CommonDataService } from "@shared/services/common-data.service";
const VIEW_LIMIT = 6;
@Component({
  selector: 'app-ceo-desk-mobile',
  templateUrl: './ceo-desk-mobile.component.html',
  styleUrls: ['./ceo-desk-mobile.component.scss']
})
export class CeoDeskMobileComponent implements OnInit, OnChanges, OnDestroy {

  @Input() years :Year[] = [] ;
  
  @Input() months: Month[] = [];

  @Input() categories: string[] = [];

  selectedCategory: string;

  selectedYear : string = "";

  selectedMonth: string = "";

  categoryGroup = new CategoryGroup(); 

  showFilter:boolean = false;

  searchText : string = '';

  viewLimit: number = VIEW_LIMIT;

  constructor(  
    private ceoDeskService:CeoDeskService,
    public apiService: ApiService,
    public sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private commonService: CommonDataService) {
  }

  ngOnInit() {
    //--- no implementation
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes['categories'] && this.categories && this.categories.length > 0){
      this.selectedCategory =   this.categories[0];
      this.getCategoryData();
    }

  }

  public globalFiterByYearMonth(change: MatSelectChange) {
   if(change.value){
    this.getCategoryData();
   }
  }


  public onCategoryChange(change: MatSelectChange){
    this.searchText ='';
    this.selectedCategory = change.value;
    if( this.selectedCategory){
      this.getCategoryData();
    }
  }

  public getCategoryData() {
    this.commonService.loaderStatus.next(true);
    const obj = {
      type: this.selectedCategory,
      year: this.selectedYear === 'All' ? "" : this.selectedYear,
      month: this.selectedMonth === 'All' ? "" : this.selectedMonth,
    };

    this.apiService.postData(Urls.readArticles, obj).subscribe(
      response => {
        if(response.status === 0){
          this.groupArticles(response.data.articles || [])
        }else{
          this.categoryGroup = new CategoryGroup();
        }

        this.viewLimit = this.categoryGroup.articles.length > VIEW_LIMIT ? VIEW_LIMIT : this.categoryGroup.articles.length;
        this.commonService.loaderStatus.next(false);
        this.cdr.detectChanges();
        this.cdr.markForCheck();
      },
      error => {
        this.categoryGroup = new CategoryGroup();
        this.commonService.loaderStatus.next(false);
      }
    )
  }

  public groupArticles(articles: Article[] ){
    this.categoryGroup = new CategoryGroup();
    this.categoryGroup.group(articles)
    this.ceoDeskService.setCategoryGroup(this.categoryGroup);
  }

  public toggleFilter(){
    this.showFilter = !this.showFilter;
  }

  public onViewMore(){
    this.viewLimit = this.categoryGroup.articles.length;
  }

  public ngOnDestroy(){
      if(this.cdr){
        this.cdr.detach();
        this.cdr =null;
      }
  }
}
